// this is a wrapper for testing, it passes fela based
// components fela's renderer and global theme

import React from 'react';
import StyleProvider from './StyleProvider';

var felaTestContext = function felaTestContext(component, renderer) {
  return React.createElement(
    StyleProvider,
    { renderer: renderer, dev: true },
    component
  );
};

export default felaTestContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-provider/es/felaTestContext.js
// module id = 627
// module chunks = 1